import React, {useState, useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { isLoggedIn, isVerifyEmail, userToken, logout } from "../../../features/user";
import { setLoading, showMessage } from "../../../features/common";
import axios from "axios";
import { API_200, API_204, API_URL, DEFAULT_ERROR_TEXT, API_EXCEPTION } from '../../../Constants';
import {Trans,  useTranslation } from 'react-i18next';
import {checkApiSessionErrorMessage, checkValidToken, userLoggedIn, getLang, arrayBufferToBase64, navigateTo, showLoading } from "../../../Helper"

import Frame from '../../widgets/Frame';
import Background from '../../widgets/Background';
import Input from '../../widgets/Input';
import DateInput from '../../widgets/DateInput';
import TextArea from '../../widgets/TextArea';
import CheckBox from '../../widgets/CheckBox';
import ImagePicker from '../../widgets/ImagePicker';
import Specialization from '../../widgets/Specialization';


export function EditProviderPortfolio() {
    const [state, setState] = useState({provider:null, errors:{}});

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const isUserLoggedIn = useSelector(isLoggedIn);
    const isUserVerifyEmail = useSelector(isVerifyEmail);

    useEffect(()=>{
        (async () => {
            await checkValidToken(navigate, dispatch, false, true, '/start');
            if(userLoggedIn(isUserLoggedIn, isUserVerifyEmail, navigate, dispatch)){
                getprovider();
            }
        })();
        // eslint-disable-next-line
    },[]);

    const getprovider = async () => {
        showLoading(dispatch, true);
        let errorMessage = DEFAULT_ERROR_TEXT;

        let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};

        try {
            const reply = await axios.get(`${API_URL }/provider/`, config);
            showLoading(dispatch, false);
            // console.log(reply.data.dateOfBirth);
            if(reply.hasOwnProperty('data') && reply.hasOwnProperty('status') && reply.status === API_200) {
                if(!reply.data.portfolio?.length > 0) {
                    reply.data.portfolio = [{}]
                }

                setState({
                    ...state,
                    provider: reply.data
                });
            }
        } catch (e) {
            showLoading(dispatch, false);
            dispatch(showMessage({message : errorMessage}));
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        if(!validateForm()) {
            showLoading(dispatch, true);
            let errorMessage = DEFAULT_ERROR_TEXT;
            
            let config = {'headers': {"Authorization": 'Bearer '+userToken(), "lang": getLang()}};
          
            const data = {portfolio: state.provider.portfolio};

            try {
                const reply = await axios.patch(API_URL + '/provider', data, config);
                showLoading(dispatch, false);
                //console.log(reply);
                if(reply.hasOwnProperty('status') && reply.status === API_204) {
                    //navigateTo(dispatch, navigate, "/provider");
                    navigateTo(dispatch, navigate, -1);
                }
            } catch (e) {
                showLoading(dispatch, false);
                if(e?.response?.data?.hasOwnProperty("errors") && e.response.data["errors"].length > 0){
                    errorMessage = e.response.data["errors"][0];
                }
                if(!checkApiSessionErrorMessage(errorMessage, dispatch, navigate, true)) {
                    dispatch(showMessage({message : errorMessage}));
                }
            }
        } else {
            dispatch(showMessage({message : 'please_fill_input'}));
        }

    };

    const handleChange = (e) => {
        change(e.target.id, e.target.value);
    };

    const change = (id, value) => {
        delete state.errors[id];
        setState({
            ...state, 
            provider:{...state.provider,
                [id]: value,
            },
            errors: {...state.errors},
        });
    };

    const changePortfolio = (index, e) => {
        state.provider.portfolio[index][e.target.id] = e.target.value;
        change('portfolio',state.provider.portfolio);
    };

    const addError = (errors, index, name, error) => {
        if(!errors.portfolio) {
            errors.portfolio = [];
        }
        while(!errors.portfolio[index]) {
            errors.portfolio.push({});
        }
        errors.portfolio[index][name] = error;
    }

    const toggleImagePicker = () => {
        setState({
            ...state,
            showImagePicker: !state.showImagePicker,
        });
    };


    const setImage = (index, image) => {
        state.provider.portfolio[index].image = image;
        setState({
            ...state,
            showImagePicker: false,
            provider:{...state.provider,
                portfolio: state.provider.portfolio,
            },
            errors: {...state.errors},
        });
    }

    const validateForm = () => {
        const errors = {};
        for (let index = 0; index < state.provider.portfolio.length; index++) {
            if (!state.provider.portfolio?.[index]?.name?.trim()) {
                addError(errors, index, 'name', 'project_name_error');
            }
            if (!state.provider.portfolio?.[index]?.work?.trim()) {
                addError(errors, index, 'work', 'work_in_project_error');
            }
        }

        setState({
            ...state,
            errors: errors,
        });

        return Object.keys(errors).length > 0;
    };

    const addPackage = (e) => {
        if(state.provider.portfolio?.length < 20) {
            state.provider.portfolio.push({});
            change('portfolio',state.provider.portfolio);
        }
    };

    const removePackage = (index) => {
        if(state.provider.portfolio?.length > 1) {
            state.provider.portfolio.splice(index, 1);
            change('portfolio',state.provider.portfolio);
        }

    };


    return (
        <Frame showMenu={true} showNav={true}>
            <div className='main main-provider-profile'>
                <div className='main-body'>
                    <div className='left-main'></div>
                    <div className='right-main'>
                        {state.provider?<Background showClouds={true} >
                            <div className='right-main-inner'>
                                <div className='mt40'>
                                    <div className='center-div font-25 font-bold text-align-center'>{t("add_project")}</div>
                                </div>

                                <div className='mt30'>
                                    <div className='center-div font-20 text-align-center'>{t("add_project_summary")}</div>
                                </div>

                                {state.provider.portfolio && state.provider.portfolio.map((item, key) => (
                                    <div key={key}>
                                        <div className='mt30'>
                                            <Input className={state.errors.portfolio?.[key]?.name?"error":""} id="name" placeholder={t("project_name")} value={item.name??''} onChange={(e) => changePortfolio(key, e)}/>
                                        </div>
                                        {state.errors.portfolio?.[key]?.name && <div className='mt5 error font-12'><Trans i18nKey={state.errors.portfolio?.[key]?.name} /></div>}

                                        <div className='mt30'>
                                            <Input className={state.errors.portfolio?.[key]?.work?"error":""} id="work" placeholder={t("work_in_project")} value={item.work??''} onChange={(e) => changePortfolio(key, e)}/>
                                        </div>
                                        {state.errors.portfolio?.[key]?.work && <div className='mt5 error font-12'><Trans i18nKey={state.errors.portfolio?.[key]?.work} /></div>}

                                        <div className='mt30'>
                                            <Input className={state.errors.portfolio?.[key]?.writer?"error":""} id="writer" placeholder={t("the_writer")} value={item.writer??''} onChange={(e) => changePortfolio(key, e)}/>
                                        </div>

                                        <div className='center-div mt30'>
                                            <div className='center-div border-1 drop-shaddow' onClick={()=>toggleImagePicker()}>
                                                {!item.image && <div className='center-div align-items-center'><img src={'/images/camera.png'} className='width-100' alt=''/></div>}
                                                {item.image && <div className=''>
                                                    <img src={arrayBufferToBase64(item.image)} className='width-100' alt=''/>
                                                </div>}
                                            </div>
                                        </div>

                                        <div className='image-picker'>
                                            {state.showImagePicker && 
                                                <ImagePicker title={t('choose_profile_picture')} onSelected={(image)=>setImage(key ,image)} onCancel={()=>toggleImagePicker()}/>
                                            }
                                        </div>


                                        {/* {state.errors.portfolio?.[key] && Object.entries(state.errors.portfolio[key]).map(([key, msg]) => (
                                            <h2 key={key} className='mt10 error'><Trans i18nKey={msg} /></h2>
                                        ))} */}
                                        {state.provider.portfolio?.length > 1 && <div className='center-div align-items-center mt20 mb60'><div className='button-form font-30 font-bold provider-add-remove-button' onClick={(e) => removePackage(key)}>  <div className='mb5'>{t("-")}</div> </div></div>}
                                    </div>
                                 ))}

                                {state.provider.portfolio?.length < 20 && <div className='center-div align-items-center mt20'><div className='button-form font-30 font-bold provider-add-remove-button' onClick={(e) => addPackage()}>  <div>{t("+")}</div> </div></div>}
                                <div className='button-form font-18 color-550952 mt20 mb40' onClick={(e) => handleSubmit(e)}>  <div>{t("save")}</div> </div>
                            </div>
                        </Background>:null}
                    </div>
                    <div className='left-main'>
                    </div>
                </div>
            </div>
        </Frame>
    );
}